import { Controller } from "@hotwired/stimulus";
import { fetcher } from "../src/utils/fetcher";

// Connects to data-controller="notification-setting"
// 通知設定ページのプルダウンを変更したら即時に保存する（保存ボタンなし）
export default class extends Controller {
  static targets = ["select", "feedback", "errorWrap"];

  declare readonly selectTarget: HTMLSelectElement;
  declare readonly feedbackTarget: HTMLElement;
  declare readonly errorWrapTarget: HTMLElement;

  previousValue: string | null = null;
  feedbackTimer: number | null = null;

  connect(): void {
    this.previousValue = this.selectTarget.value;
  }

  disconnect(): void {
    if (this.feedbackTimer !== null) {
      window.clearTimeout(this.feedbackTimer);
      this.feedbackTimer = null;
    }
  }

  async updateSetting(): Promise<void> {
    const value = this.selectTarget.value;

    // 2回目以降の保存でもアニメーションが再生されるよう、成功表示とエラー表示を一旦隠してから保存を始める（mock と同じ順番）
    this.feedbackTarget.hidden = true;
    if (this.feedbackTimer !== null) {
      window.clearTimeout(this.feedbackTimer);
      this.feedbackTimer = null;
    }
    this.errorWrapTarget.hidden = true;

    this.selectTarget.disabled = true;

    try {
      await fetcher.patch("/api/internal/v1/notification_settings", {
        is_relisting_on: value === "true"
      });

      this.previousValue = value;
      this.showFeedback();
    } catch {
      // 失敗したら選択値を直前の保存値に戻し、見出し上にエラーを表示する
      if (this.previousValue !== null) {
        this.selectTarget.value = this.previousValue;
      }
      this.errorWrapTarget.hidden = false;
    } finally {
      this.selectTarget.disabled = false;
      // disabled 中にフォーカスが外れるため、保存後にプルダウンへフォーカスを戻す
      this.selectTarget.focus();
    }
  }

  // 保存完了の表示を一定時間で消す
  showFeedback(): void {
    this.feedbackTarget.hidden = false;

    if (this.feedbackTimer !== null) {
      window.clearTimeout(this.feedbackTimer);
    }
    this.feedbackTimer = window.setTimeout(() => {
      this.feedbackTarget.hidden = true;
    }, 2000);
  }
}
